import { Box, HStack, VStack } from '@chakra-ui/react';
import Text from '../../../../../../components/content/text';
import Button from '../../../../../../components/inputs/button';
import { useTranslation } from 'react-i18next';
import { tKeys } from '../../../../../../translations/keys';
import { Kind } from '../../../../../../components/inputs/button/constants/kind';
import React from 'react';
import COLORS from '../../../../../../constants/colors';
import FONTS from '../../../../../../constants/fonts';
import { usePreviewMinutesLogic } from './logic.web';
import { Size } from '../../../../../../components/inputs/button/constants/size';
import ConfirmationDialog from '../../../../../../components/feedback/confirmation-dialog/index.web';
import DropzoneInput from '../../../../../../components/inputs/dropzone/index.web';
export const EventDetailsPreviewMinutes = ({ eventId, isAdmin, isHtmlMinutesGenerated, }) => {
    // Attributes
    const { t } = useTranslation();
    const { isOpenPopover, onTogglePopover, isLoading, handleGenerateClick, handleOnPressDocument, isDocumentLoading, handleUploadDocument, handleEditMinutes, isUploading, isEditing, confirmGenerateMinutes, isMinuteAlreadyGenerated, isConfirmDialogOpen, openConfirmDialog, closeConfirmDialog, handleRegenerateConfirmed, } = usePreviewMinutesLogic(eventId);
    // Render
    return (<VStack width={'full'} bgColor={COLORS.White.T500.value} p={'1.25rem'} spacing={4} borderRadius="md" boxShadow="sm">
      <HStack width={'full'} justifyContent={'space-between'} alignItems={'center'}>
        <VStack alignItems="flex-start" spacing={1}>
          <HStack alignItems="center" spacing={2}>
            <Box width="10px" height="10px" borderRadius="full" backgroundColor={isMinuteAlreadyGenerated
            ? COLORS.Success.T500.value
            : COLORS.Warning.T500.value}/>
            <Text font={FONTS.T1.T16Px.SemiBold600.value} numberOfLines={1}>
              {t(tKeys.event.details.preview_minutes.title) ||
            'Meeting Minutes'}
            </Text>
          </HStack>
          <Text font={FONTS.T1.T12Px.Regular400.value} color={COLORS.Text.T300.value} numberOfLines={2}>
            {isMinuteAlreadyGenerated
            ? t(tKeys.event.details.preview_minutes.minutes_available) ||
                'Document has been created and is ready to view'
            : t(tKeys.event.details.preview_minutes.no_minutes) ||
                'No minutes document has been created yet'}
          </Text>
        </VStack>

        {/* Primary action for all users */}
        <Button size={Size.MEDIUM} kind={Kind.SECONDARY} onPress={() => handleOnPressDocument()} isLoading={isDocumentLoading} isDisabled={isDocumentLoading || !isMinuteAlreadyGenerated} leftIcon={isMinuteAlreadyGenerated ? 'document-text' : 'eye-off'} data-testid="view-minutes-button">
          {isMinuteAlreadyGenerated
            ? t(tKeys.event.details.preview_minutes.view) || 'View Minutes'
            : t(tKeys.event.details.preview_minutes.not_available) ||
                'No Document Yet'}
        </Button>
      </HStack>

      {isAdmin && (<VStack width={'full'} spacing={3}>
          <HStack justifyContent="space-between" alignItems="center" width="full">
            <Text font={FONTS.T1.T14Px.Medium500.value} color={COLORS.Text.T400.value} alignSelf="flex-start" borderBottom={`1px solid ${COLORS.Line.value}`} paddingBottom="2px">
              {t(tKeys.event.details.preview_minutes.admin_options) ||
                'Document Management Options'}
            </Text>
          </HStack>

          <HStack width={'full'} justifyContent={'flex-end'} spacing={3}>
            {/* Upload button */}
            {/*
            <Button
              size={Size.SMALL}
              kind={Kind.SECONDARY}
              onPress={handleUploadDocument}
              isLoading={isUploading}
              leftIcon="upload-cloud"
              data-testid="upload-minutes-button"
              title={t(tKeys.event.details.preview_minutes.upload_tooltip) || "Upload an existing minutes document file"}
            >
              {t(tKeys.event.details.preview_minutes.upload) || "Upload Document"}
            </Button> */}

            {/* Edit option available when minutes exist */}
            {isHtmlMinutesGenerated && (<Button size={Size.SMALL} kind={Kind.OUTLINE} onPress={handleEditMinutes} isLoading={isEditing} leftIcon="pencil" data-testid="edit-minutes-button" title={t(tKeys.event.details.preview_minutes.edit_tooltip) ||
                    'Edit the content of the minutes'}>
                {t(tKeys.event.details.preview_minutes.edit) || 'Edit Content'}
              </Button>)}

            {/* Generate button with clear dropdown indicator */}
            <Button size={Size.SMALL} kind={isMinuteAlreadyGenerated ? Kind.OUTLINE : Kind.SECONDARY} isLoading={isLoading} onPress={isHtmlMinutesGenerated
                ? openConfirmDialog
                : async () => await handleGenerateClick('fr-FR')} leftIcon={isHtmlMinutesGenerated ? 'refresh' : 'sparkles'} rightIcon={isHtmlMinutesGenerated ? undefined : 'chevron-down'} data-testid="generate-minutes-button" title={isHtmlMinutesGenerated
                ? t(tKeys.event.details.preview_minutes.regenerate_tooltip) ||
                    'Create a new version of the minutes'
                : t(tKeys.event.details.preview_minutes.generate_tooltip) ||
                    'Generate minutes in your preferred language'}>
              {isHtmlMinutesGenerated
                ? t(tKeys.event.details.preview_minutes.regenerate) ||
                    'Regenerate'
                : t(tKeys.common.generate) || 'AI Generate'}
            </Button>
          </HStack>
          {!isMinuteAlreadyGenerated && (<DropzoneInput onDrop={handleUploadDocument} isLoading={isUploading}/>)}

          {/* Add the confirmation dialog component */}
          <ConfirmationDialog isOpen={isConfirmDialogOpen} onClose={closeConfirmDialog} onConfirm={handleRegenerateConfirmed} title={t('event.details.preview_minutes.confirm_regenerate_title') ||
                'Regenerate Minutes?'} message={t('event.details.preview_minutes.confirm_regenerate_message') ||
                'This will replace the existing minutes document. This action cannot be undone.'} confirmButtonText={t('event.details.preview_minutes.regenerate') || 'Yes, Regenerate'} cancelButtonText={t('common.cancel') || 'Cancel'}/>

          {/* <PopOver
              from={null}
              triggerRef="generate-minutes-button"
              placement="bottom-end"
              isOpen={isOpenPopover}
              onToggle={onTogglePopover}
            >
              <VStack
                alignItems={'flex-start'}
                width={'full'}
                py={'.5rem'}
                spacing={0}
                minWidth="200px"
                boxShadow="sm"
                bgColor={COLORS.White.T500.value}
                borderRadius="md"
              >
                <Text
                  font={FONTS.T1.T14Px.Medium500.value}
                  color={COLORS.Text.T400.value}
                  px={'1rem'}
                  py={'.5rem'}
                  borderBottom={`1px solid ${COLORS.Line.value}`}
                  width="full"
                >
                  {t(tKeys.event.details.preview_minutes.language_selection) || "Select Language"}
                </Text>
                
                <Box
                  py={'.75rem'}
                  px={'1rem'}
                  width={'full'}
                  _hover={{ backgroundColor: COLORS.Tag.value }}
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={async () => await handleGenerateClick('fr-FR')}
                  cursor={'pointer'}
                  borderRadius="sm"
                  transition="background-color 0.2s"
                >
                  <HStack alignItems="center" spacing={2}>
                    <Text>🇫🇷</Text>
                    <Text
                      font={FONTS.T1.T14Px.Regular400.value}
                      color={COLORS.Text.T400.value}
                    >
                      {t(tKeys.calendar.event_details.generateMinutesFrench) || "French"}
                    </Text>
                  </HStack>
                </Box>
                
                <Box
                  py={'.75rem'}
                  px={'1rem'}
                  width={'full'}
                  _hover={{ backgroundColor: COLORS.Tag.value }}
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={async () => await handleGenerateClick('en-GB')}
                  cursor={'pointer'}
                  borderRadius="sm"
                  transition="background-color 0.2s"
                >
                  <HStack alignItems="center" spacing={2}>
                    <Text>🇬🇧</Text>
                    <Text
                      font={FONTS.T1.T14Px.Regular400.value}
                      color={COLORS.Text.T400.value}
                    >
                      {t(tKeys.calendar.event_details.generateMinutesEnglish) || "English"}
                    </Text>
                  </HStack>
                </Box>
                
                <Box
                  py={'.75rem'}
                  px={'1rem'}
                  width={'full'}
                  _hover={{ backgroundColor: COLORS.Tag.value }}
                  // eslint-disable-next-line @typescript-eslint/no-misused-promises
                  onClick={async () => await handleGenerateClick('nl-NL')}
                  cursor={'pointer'}
                  borderRadius="sm"
                  transition="background-color 0.2s"
                >
                  <HStack alignItems="center" spacing={2}>
                    <Text>🇳🇱</Text>
                    <Text
                      font={FONTS.T1.T14Px.Regular400.value}
                      color={COLORS.Text.T400.value}
                    >
                      {t(tKeys.calendar.event_details.generateMinutesNL) || "Dutch"}
                    </Text>
                  </HStack>
                </Box>
              </VStack>
            </PopOver> */}
        </VStack>)}
    </VStack>);
};
